import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import Layout from '../../layouts'
import LargeHero from '../../components/elements/largeHero'
import { Body, SizedText, Canon } from '../../components/elements/typography'
import Grid from '../../components/elements/grid'
import Icon from '../../components/elements/icon'
import pdfIcon from '../../theme/icons/envelope-outline.svg'
import arrowIcon from '../../theme/icons/right-arrow.svg'
import carrotIcon from '../../theme/icons/right-carrot.svg'
import { Link } from 'gatsby'
import ExternalLink from '../../components/elements/externalLink'
import SEO from '../../components/elements/seo'
import PhExternalLink from '../../components/elements/externalLink'

const QuickLinkButton = ({to , text}) => (
  <div css={{margin: `1.5rem 0`, fontSize: `1rem`}}>
    <Link to={to} 
      css={{
        padding: `0.85rem 1.5rem 0.75rem 1.5rem`,
        border: `1px solid #2c3e50`,
        backgroundColor: `#3065d9`,
        borderRadius: `0.5rem`,
        color: `#fff !important`,
        textDecoration: `none`,
        display: `flex`,
        justifyContent: `space-between`,
        transition: `all 0.4s ease-in-out`,
        '&:hover': {
          backgroundColor: `#2a51ab`,
        }
      }}>
      <span>{text}</span>
      <span css={{paddingLeft: `0.75rem`, fontSize: `1.125rem`}}><Icon icon={carrotIcon} overrides={{verticalAlign: `-0.12rem !important`}}/></span>           
    </Link>
  </div>
)

const QuickLinkChatButton = ({to , text}) => {
  const openInNewTab = (e, url) => {
    e.preventDefault()
    window.open(url, 'testWindow', `
    toolbar=no,
    location=no,
    status=no,
    menubar=no,
    scrollbars=yes,
    resizable=yes,
    width=520,
    height=800`);
    return false
  };

  return (
  <div css={{margin: `1.5rem 0`, fontSize: `1rem`}}>
    <a href="" 
    onClick={(e) => openInNewTab(e, 'https://videobanking.tcbga.bank/embed/invochat')}
      css={{
        padding: `0.85rem 1.5rem 0.75rem 1.5rem`,
        border: `1px solid #2c3e50`,
        backgroundColor: `#3065d9`,
        borderRadius: `0.5rem`,
        color: `#fff !important`,
        textDecoration: `none`,
        display: `flex`,
        justifyContent: `space-between`,
        transition: `all 0.4s ease-in-out`,
        '&:hover': {
          backgroundColor: `#2a51ab`,
        }
      }}>
      <span>{text}</span>
      <span css={{paddingLeft: `0.75rem`, fontSize: `1.125rem`}}><Icon icon={carrotIcon} overrides={{verticalAlign: `-0.12rem !important`}}/></span>           
    </a>
  </div>
)
    }


const ContactPage = () => {
  return (
    <Layout isSubMenuOpen={true} openAccountLink={true}>

      <SEO
        title="Contact The Claxton Bank"
        description="The Claxton Bank is here for you! If you would like to learn more about our products and services, how we support the community, or if you have a question or concern about your account, don't hesitate to reach out to us."
        location="/about/contact"
        ogImg='/images/social-graph/the-claxton-bank.jpg'
      />

      <LargeHero.Container
        padding="3rem 0 4rem 0"
        background={{
          backgroundImage: `url(/images/background-deltas.jpg)`, 
          backgroundRepeat: `no-repeat`, 
          backgroundAttachment: `scroll`, 
          backgroundPosition: `top left`, 
          backgroundSize: `cover`,
        }}
        breadcrumbLinks={[
          { path: "/", text: "Home" },
          { path: "/about/", text: "About Us" },
          { path: "/about/contact", text: "Contact Us" },
        ]}
        styles={{
          paddingBottom: `5rem`,
          overflow: `hidden`,
          '.breadcrumbs, .breadcrumbs [aria-current="page"]': {color: `#fff`},
          '.heroContent': { paddingBottom: `3rem`},
          '@media (min-width: 680px)': {
            '.heroContent': { width: `calc(52% - 1rem)`, marginBottom: `0`},
            '.heroImage': { width: `calc(40% - 1rem) !important`,},
          }
        }}
      >
        <LargeHero.Content styles={{paddingTop: `1rem`, color: `#fff`}}>
          <LargeHero.Eyebrow text="About Us" styles={{borderColor: `#fff !important`}}/>
          <h1 css={{fontFamily: `Proxima-nova`, textTransform: `uppercase`,  'span': {display: `block`, lineHeight: `1`, padding: `0.5rem 0`}}}>
            <SizedText as="span" smallSize="2.281" largeSize="4.624">Contact Us</SizedText>
          </h1>
          <p css={{fontSize: `1rem`, maxWidth: `850px`, padding: `0 0 1.25rem 0`, lineHeight: `1.75`, textAlign:`justify`, hyphens: `auto` }}>
            The Claxton Bank is here for you! If you would like to learn more about our products and services, how we support the community, or if you have a question or concern about 
            your account, don't hesitate to reach out to us. The more feedback we can get from you the better we can serve you. We are available by phone, email, online, or you can 
            visit one of our branches. We look forward to helping you.
          </p>  
          <div css={{margin: `2rem 0`, fontSize: `1rem`}}>
            <Link to="/about/contact/message" css={{
              padding: `0.85rem 1.5rem 0.75rem 1.5rem`,
              backgroundColor: `#2ecc71`,
              marginRight: `2rem`,
              borderRadius: `0.5rem`,
              color: `#fff !important`,
              textDecoration: `none`
            }}>
              <span css={{paddingRight: `0.75rem`, fontSize: `1.802rem`}}><Icon icon={pdfIcon} overrides={{verticalAlign: `-0.55rem !important`}}/></span>
              <span>Send Us A Message</span>
              <span css={{paddingLeft: `0.75rem`, fontSize: `1.266rem`}}><Icon icon={arrowIcon} overrides={{verticalAlign: `-0.35rem !important`}}/></span>         
            </Link>
          </div>
        </LargeHero.Content>
        <LargeHero.Image >
          <StaticImage 
              css={{
                '@media (min-width: 680px)': { display: 'none !important' }, 
                '@media (min-width: 1300px)': { display: 'block !important' } 
              }} 
              src="../../images/contact-us.png" 
              alt=""
            />
            <StaticImage 
              css={{
                display: `none !important`,  
                '@media (min-width: 680px)': { display: 'block !important' }, 
                '@media (min-width: 1300px)': { display: 'none !important' } 
              }} 
              src="../../images/contact-us_cropped.png" 
              alt=""
            />
        </LargeHero.Image>
      </LargeHero.Container>

      <Grid.FullWidthSection 
        css={{
          padding: `2rem 0`, 
          backgroundColor: `#fff`, 
          //gridTemplateRows: `repeat(3, fit-content)`
        }}>

        {/* --- Routing Number & Buttons ---*/}
        <Grid.Block start={[2,2,2,2,2,2,3]} span={[12,12,7,7,3,2,2]} css={{
          '@media (min-width: 736px)': {
            gridRow: `1/2`,
            '@media (min-width: 1024px)': { paddingTop: `3rem` }
          }
        }}>
          <div css={{
            borderBottom: `2px solid #bdc3c7`,
            borderTop: `2px solid #bdc3c7`,
            padding: `2rem 1rem`,
          }}>
            <SizedText as="h2" smallSize="1.266" largeSize="1.424">
              TCB's Routing Number:
            </SizedText>
            <SizedText as="p" smallSize="1.125" largeSize="1.266" css={{paddingTop: `1rem`}}>
              061212015
            </SizedText>
          </div>

          {/*-- Quick Link Buttons --*/}
          <div css={{
            padding: `2rem 0`, 
            borderBottom: `2px solid #bdc3c7`,
            '@media (min-width: 736px)': {
              borderBottom: `none`,
            },
            '@media (min-width: 1024px)': {
              borderBottom: `2px solid #bdc3c7`,
            },
          }}>
            <QuickLinkButton to="/about/contact/message" text="Send Us A Message" />
            <QuickLinkChatButton to="" text="Chat with a Live Agent" />
            <QuickLinkButton to="https://theclaxtonbank.myebanking.net/#/forgot-password" text="Reset Digital Banking Password" />
            {/* <QuickLinkButton to="/resources/forms/check-order-form" text="Re-Order Checks Online" />
           <QuickLinkButton to="" text="Schedule an Appointment" /> */}
          </div> 
        </Grid.Block>

        {/*-- Quick Links --*/}
        <Grid.Block 
          start={[2,2,11,9,2,2,3]} 
          span={[12,12,2,2,3,2,2]} 
          css={{
            gridRow: `3/4`,
            '@media (min-width: 736px)': {
              gridRow: `1/2`,
            },
            '@media (min-width: 1024px)': {
              gridRow: `2/3`,
            },
            
          }}>

        
          <div css={{
            padding: `2rem 1rem`,
            '@media (min-width: 736px)': {
              paddingTop: `0.5rem`
            },
            '@media (min-width: 1024px)': {
              paddingTop: `2rem`,
              borderBottom: `2px solid #bdc3c7`,
            },
            'ul': {
              padding: `1rem 0 0 0`,
              width: `300px`,
              listStyle: `none`,
              'li a': {
                display: `block`,
                padding: `0.25rem 0` 
              }
            }
          }}>
            <SizedText as="h2" smallSize="1.266" largeSize="1.424">
              Quick Links Menu
            </SizedText>
            <ul>
              <li><Link to="/about/locations">Branch Locations</Link></li>
              <li><Link to="/about/holidays-and-cutoffs">Holiday Schedule</Link></li>
              <li><Link to="mailto:abuse@tcbga.bank">Report a Security Incident</Link></li>
              <li><Link to="/about/careers">Careers & Open Positions</Link></li>
              <li><a href="https://theclaxtonbank.myebanking.net/#/forgot-password">Reset Digital Banking Password</a></li>
              <li><a href="https://theclaxtonbank.csinufund.com/home/newUser">Apply for an Account</a></li>
              {/* <li><Link to="/resources/product-tips/understanding-your-balance">Understanding Your Balance</Link></li>
              <li><Link to="/resources/product-tips/debit-card-faqs">Debit Card FAQs</Link></li>
              <li><Link to="/resources/product-tips/digital-banking-faqs">Digital Banking FAQs</Link></li>
              <li><Link to="/resources/product-tips/mobile-deposit-faqs">Mobile Deposit FAQs</Link></li>
              <li><Link to="/resources/product-tips/loan-faqs">Loan FAQs</Link></li> */}
            </ul>
          </div>


        </Grid.Block>

        <Grid.Block 
          start={[2,2,2,2,5,5,6]} 
          span={[12,12,12,9,9,9,7]} 
          css={{
            overflow: `none !important`,
            '@media (min-width: 736px)': {
              borderTop: `2px solid #bdc3c7`,
            },
            '@media (min-width: 1024px)': {
              gridRow: `1/4`,
              borderTop: `none`, 
            },
          }}>
          <div css={{
            marginTop: `3rem`, 
            '.contactSection': {
              borderBottom: `2px solid #bdc3c7`,
              padding: `0 1rem 4rem 1rem`,
              marginBottom: `4rem`,
              '&:last-of-type': {
                '@media (min-width: 736px)': { borderBottom: `none` },
              },
              '> div': {
                paddingLeft: `0.5rem`,
                '@media (min-width: 736px)': {
                  display: `grid`,
                  gridTemplateColumns: `1fr 1fr`,
                  gridGap:`2rem`
                },
                '@media (min-width: 1495px)': {
                  gridTemplateColumns: `1fr 1fr 1fr`,
                  gridGap:`2rem`
                },                
              },
              'h1': { marginBottom: `0rem`},
              'h2': {
                padding: `2rem 0 0.25rem 0`,
              }
            }
          }}>

            {/** ---- Contact Customer Care ---- */}
            <div className="contactSection">
              <Canon>Contact TCB Customer Care</Canon>
              <div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1" css={{paddingBottom: `1rem`}}>
                    Phone Support
                  </SizedText>
                  <Body>
                    1-912-739-3322<br />
                    8:00 AM - 6:00 PM EST <small>(Monday – Friday)</small><br />
                    9:00 AM – 2:00 PM EST <small>(Saturday)</small>
                  </Body>
                </div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1" css={{paddingBottom: `1rem`}}>
                    Corporate Address
                  </SizedText>
                  <Body>
                    121 West Main Street<br />
                    Claxton, Georgia 30417
                  </Body>
                </div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1" css={{paddingBottom: `1rem`}}>
                    Mailing Address
                  </SizedText>
                  <Body>
                    P.O. Box 247<br />
                    Claxton, Georgia 30417
                  </Body>
                </div>
              </div>
            </div>

            {/** ---- TCB Product Support ---- */}
            <div className="contactSection">
              <Canon>TCB Product Support</Canon>
              <div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    24/7 Telephone Banking
                  </SizedText>
                  <Body>
                    1-912-739-7693
                  </Body>
                </div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    Lost or Stolen Debit Card
                  </SizedText>
                  <Body>
                    1-912-739-3322 <small>(Normal Business Hours)</small><br />
                    1-844-202-5333 <small>(After Hours)</small>
                  </Body>
                </div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    Credit Card Support
                  </SizedText>
                  <Body>
                    1-800-367-7576
                  </Body>
                </div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    BillPay Support
                  </SizedText>
                  <Body>
                    1-844-819-3608
                  </Body>
                </div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    Treasury Services
                  </SizedText>
                  <Body>
                    1-912-739-5646
                  </Body>
                </div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    Merchant Services Support
                  </SizedText>
                  <Body>
                    1-800-449-8012
                  </Body>
                </div>
              </div>
            </div>   

            {/** ---- Branch Contacts ---- */}
            <div className="contactSection">
              <Canon>Branch Location Contacts</Canon>
              <div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    Main Branch
                  </SizedText>
                  <Body>
                    121 West Main Street<br />
                    Claxton, GA 30417<br />
                    912-739-5600
                  </Body>
                </div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    Jacksonville Branch
                  </SizedText>
                  <Body>
                    1 Independent Drive, Suite 1800 <br />
                    Jacksonville, FL 32202<br />
                    904-717-7220
                  </Body>
                </div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    Square Branch
                  </SizedText>
                  <Body>
                    400 North Duval Street <br />
                    Claxton, GA 30417<br />
                    912-739-5602
                  </Body>
                </div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    Richmond Hill Branch
                  </SizedText>
                  <Body>
                    2591 Hwy 17, Suite 201<br />
                    Richmond Hill, GA 31324<br />
                    912-445-7005
                  </Body>
                </div>
                
              </div>
            </div>

            {/** ---- Additional Contacts ---- */}
            <div className="contactSection">
              <Canon>Additional Contacts</Canon>
              <div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    Press & Marketing Inquiries
                  </SizedText>
                  <Body>
                    1-912-739-5662<br />
                    Troy A. Poulin
                  </Body>
                </div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    Investor Relations
                  </SizedText>
                  <Body>
                    904-717-7051<br />
                    Scott Verlander
                  </Body>
                </div>
                <div>
                  <SizedText as="h2" smallSize="1" largeSize="1">
                    Careers
                  </SizedText>
                  <Body>
                    <Link to="/about/careers">TCB Career Center --></Link> <br />
                    <PhExternalLink to="mailto:careers@tcbga.bank" emailLink={true}>careers@tcbga.bank</PhExternalLink>
                  </Body>
                </div>
              </div>
            </div>

            {/** ---- Fraudlent Activity ---- */}
            <div className="contactSection">
              <Canon>Report Suspicious or Fraudulent Activity</Canon>
              <Body css={{padding: `2rem 0 0.25rem 0`}}>
                If you believe your personal information has been compromised, immediately contact The Claxton Bank at 912-739-3322 and file a consumer complaint with 
                the <ExternalLink to="https://reportfraud.ftc.gov/#/?pid=B">FTC</ExternalLink>.  If you have received a suspicious communication through email, text message, or social media, you can also forward the conversation to 
                &nbsp; <PhExternalLink to="mailto:abuse@tcbga.bank" emailLink={true}>abuse@tcbga.bank</PhExternalLink>.  
              </Body>
            </div>

            {/** ---- Vulnerability ---- */}
            <div className="contactSection" css={{marginBottom: `2rem !important`}}>
              <Canon>Reporting a Suspected Vulnerability</Canon>
              <Body>
                The Claxton Bank is committed to the security of our systems. We appreciate any submission by security professionals and research identifying any 
                potential security gaps in our products and services.  When reporting a potential vulnerability, please include a detailed summary of the vulnerability, 
                including the target, steps, tools, and artifacts used during discovery (screen captures welcome). Please submit reports to <PhExternalLink to="mailto:responsibledisclosure@tcbga.bank" emailLink={true}>responsibledisclosure@tcbga.bank</PhExternalLink>.   
              </Body>
            </div>
          </div>
        </Grid.Block>

        
      </Grid.FullWidthSection>
    </Layout> 
  )
}

export default ContactPage




